import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { Logo } from '../Logo';
const NAV_LINKS: {
  label: string;
  href: string;
}[] = [{
  label: '課題',
  href: '#problem'
}, {
  label: 'AI受付スタッフ',
  href: '#ai-staff'
}, {
  label: '導入の流れ',
  href: '#process'
}, {
  label: 'よくある質問',
  href: '#faq'
}, {
  label: 'お問い合わせ',
  href: '#contact'
}];
export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const goToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/' + href);
      return;
    }
    document.querySelector(href)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="w-full bg-deep-navy text-white" data-id="element-198" data-mp="13nbq3dabugxi">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6" data-id="element-199" data-mp="ypiicftdlev4">
        <div className="grid gap-10 md:grid-cols-2" data-id="element-200" data-mp="1eic1d1xx48o2">
          <div data-id="element-201" data-mp="1ehkf4hq7nnag">
            <Logo variant="plain" size="md" data-id="element-202" data-mp="1efzkyt7t66d4" />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/75" data-id="element-203" data-mp="1iivyi5ihrca7">
              横須賀地域の中小企業のための、伴走型デジタルパートナー。
              ITの知識がなくても、現場の困りごとを一緒に解決します。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-white/75" data-id="element-204" data-mp="1s97cylzsx3vc">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-205" data-mp="1sbbewye53ssz" />
              神奈川県横須賀市
            </p>
          </div>

          <nav aria-label="フッターナビゲーション" className="md:justify-self-end" data-id="element-206" data-mp="zkjlu9sdfk9v">
            <p className="text-sm font-bold text-white" data-id="element-207" data-mp="14jd2gb2yfre9">サイト内リンク</p>
            <ul className="mt-4 space-y-2" data-id="element-208" data-mp="14m8z7w32ga14">
              {NAV_LINKS.map(l => <li key={l.href} data-id="element-209" data-mp="19gwfj7nx1y4m">
                  <a href={l.href} onClick={e => goToSection(e, l.href)} className="text-sm text-white/75 transition-colors hover:text-white focus:outline-none focus-visible:text-white" data-id="element-210" data-mp="2fzbf0oxccvk8">
                    {l.label}
                  </a>
                </li>)}
              <li data-id="element-211" data-mp="1qanykhhlics7">
                <RouterLink to="/about" className="text-sm text-white/75 transition-colors hover:text-white focus:outline-none focus-visible:text-white" data-id="element-212" data-mp="1qda1u4xge64m">
                  会社概要
                </RouterLink>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-white/15 pt-6 text-xs text-white/60 sm:flex-row sm:items-center sm:justify-between" data-id="element-213" data-mp="17ko93thuevo9">
          <p data-id="element-214" data-mp="1man7nxdb8949">© 2026 OptiDSA. All rights reserved.</p>
          <p data-id="element-215" data-mp="1hi2f0z65422b">横須賀の中小企業のデジタル変革を、伴走で。</p>
        </div>
      </div>
    </footer>;
}